import {mapValues} from '#core/utils/utils.js';

const getMatchSportsDefaultPagePriority = (matchSportsDefaultPagePriority, defaultValue, overriddenSports = {}) => {
    const sports = {
        default: matchSportsDefaultPagePriority[defaultValue],
    };

    for (const sportId in overriddenSports) {
        sports[sportId] = matchSportsDefaultPagePriority[overriddenSports[sportId]];
    }

    return sports;
};

const getSportBackgroundImages = ({
    sportBackgroundImageMap,
    folderName = '',
    extension = 'png',
    alternateExtensionImageMap,
}) => {
    let images = mapValues(sportBackgroundImageMap, imgName => `sport-page/${folderName}/${imgName}.${extension}`);

    if (alternateExtensionImageMap) {
        const altExtension = extension === 'png' ? 'svg' : 'png';
        const additionalImages = mapValues(
            alternateExtensionImageMap,
            imgName => `sport-page/${folderName}/${imgName}.${altExtension}`
        );
        images = {
            ...images,
            ...additionalImages,
        };
    }

    return images;
};

export {getMatchSportsDefaultPagePriority, getSportBackgroundImages};
